import Image from 'next/image'

import Link from '@/atoms/Link/Link'

interface Props {
  eventType: string | undefined
  thankYouMessage: string
  recordingUrl?: string
}

function ThankYou({ eventType, thankYouMessage, recordingUrl }: Props) {
  return (
    <section>
      <div className="flex flex-wrap gap-12 md:gap-28 justify-center items-center">
        <div className="text-blue-web-90 | max-w-col-4">
          {eventType === 'Past_Event' ? (
            <>
              <h3 className="text-3xl font-semibold | mb-5 md:mb-9">
                Thank you for showing interest!
              </h3>
              <p className="text-sm md:text-xl | mb-2">
                Your response has been recorded.
              </p>
              <p className="text-sm md:text-xl | mb-2">
                We&apos;ve received your request for the event recording.
              </p>
              <p className="text-sm md:text-xl">
                Sit tight, and we&apos;ll have it winging its way to your inbox
                shortly.
              </p>
              {recordingUrl ? (
                <Link
                  href={recordingUrl}
                  target="_blank"
                  className="flex gap-2 | text-sm md:text-lg font-medium capitalize | w-full new-btn-primary"
                >
                  watch full video
                </Link>
              ) : null}
            </>
          ) : (
            <>
              <h3 className="text-3xl md:text-4xl font-semibold | mb-5 md:mb-9">
                Thank you for registering!
              </h3>
              <div
                className="text-sm md:text-xl | mb-5 md:mb-9"
                dangerouslySetInnerHTML={{ __html: thankYouMessage }}
              />
            </>
          )}
        </div>
        <Image
          src="/assets/events/thank-you.png"
          alt=""
          width={363}
          height={262}
        />
      </div>
    </section>
  )
}

export default ThankYou
